var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExamination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Examination"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3 9.99951C3 8.34266 4.34315 6.99951 6 6.99951H18C19.6569 6.99951 21 8.34266 21 9.99951V17.9995C21 19.6564 19.6569 20.9995 18 20.9995H6C4.34315 20.9995 3 19.6564 3 17.9995V9.99951Z",
    fill: "#A461D8",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.99951C9.44772 4.99951 9 5.44723 9 5.99951V6.99951H7V5.99951C7 4.34266 8.34315 2.99951 10 2.99951H14C15.6569 2.99951 17 4.34266 17 5.99951V6.99951H15V5.99951C15 5.44723 14.5523 4.99951 14 4.99951H10Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.9995C11.4477 10.9995 11 11.4472 11 11.9995V12.9995H10C9.44772 12.9995 9 13.4472 9 13.9995C9 14.5518 9.44772 14.9995 10 14.9995H11V15.9995C11 16.5518 11.4477 16.9995 12 16.9995C12.5523 16.9995 13 16.5518 13 15.9995V14.9995H14C14.5523 14.9995 15 14.5518 15 13.9995C15 13.4472 14.5523 12.9995 14 12.9995L13 12.9995V11.9995C13 11.4472 12.5523 10.9995 12 10.9995Z",
    fill: "#A461D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamination);
export default __webpack_public_path__ + "static/media/Examination.591691999fe34a4a27e45a0c1558ce91.svg";
export { ForwardRef as ReactComponent };